/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolKeyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-key"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.9 15Q6.9 15 6.28 15Q5.65 15 4.78 14.13Q3.9 13.25 3.9 12Q3.9 10.75 4.78 9.88Q5.65 9 6.9 9Q8.15 9 9.03 9.88Q9.9 10.75 9.9 12Q9.9 13.25 9.03 14.13Q8.15 15 6.9 15ZM6.9 18.1Q8.88 18.1 10.36 17.02Q11.85 15.95 12.43 14.25L12.78 14.25L13.5 15Q13.7 15.2 13.94 15.3Q14.18 15.4 14.43 15.4Q14.68 15.4 14.91 15.31Q15.15 15.22 15.35 15.03L16.7 13.68L17.85 14.82Q18.05 15.03 18.29 15.11Q18.52 15.2 18.77 15.2Q19.02 15.2 19.26 15.11Q19.5 15.03 19.7 14.82L21.63 12.93Q21.82 12.72 21.91 12.49Q22 12.25 22 12Q22 11.75 21.91 11.51Q21.82 11.28 21.63 11.07L20.68 10.13Q20.48 9.93 20.25 9.84Q20.02 9.75 19.75 9.75L12.43 9.75Q11.78 8.1 10.34 7Q8.9 5.9 6.9 5.9Q4.4 5.9 2.6 7.7Q0.8 9.5 0.8 12Q0.8 14.5 2.6 16.3Q4.4 18.1 6.9 18.1Z" fill={color} />
    </svg>
  );
}
